import { createSelector } from 'reselect';
import { hashHistory } from 'react-router';
import { get, keys, includes, isEmpty } from 'lodash';
import { DEFAULT_LOCALE, AVAILABLE_LOCALES, SEARCH_FACETS } from '../utils/constants';
import { extractFacetIdsFromLocationQuery, parseDate } from '../utils';

const availableLocaleKeys = keys(AVAILABLE_LOCALES);
export const getLocale = () => {
  const locale = get(hashHistory.getCurrentLocation(), 'query.lang', DEFAULT_LOCALE);
  return includes(availableLocaleKeys, locale) ? locale : DEFAULT_LOCALE;
};
export const getAvailableLocales = () => AVAILABLE_LOCALES;

export const getConfig = state => get(state, 'config');
export const getSearchResults = state => get(state, 'recalls.data', []);
export const getSearchUiFacets = state => get(state, 'recalls.availableFacets', {});
export const getSearchExpandedFacetBlocks = state => get(state, 'recalls.expandedFacetBlocks');
export const getSearchFacetSpotlights = state => get(state, 'recalls.facetSpotlightSearches');
export const getSearchResponseInfo = state => get(state, 'recalls.responseInfo');
export const getSearchIsFetching = state => get(state, 'recalls.isFething');
export const getSearchLoadedQuery = state => get(state, 'recalls.loadedQuery');
export const getSearchLocationQuery = () => get(hashHistory.getCurrentLocation(), 'query');
export const getSearchSortBy = createSelector(
  getSearchLocationQuery,
  query => get(query, 'sort', 'date'),
);
export const getSearchSortOrder = createSelector(
  getSearchLocationQuery,
  query => get(query, 'order', 'DESC'),
);
export const getSearchTerm = createSelector(
  getSearchLocationQuery,
  query => get(query, 'searchTerm'),
);
export const getSearchResultsPage = createSelector(
  getSearchLocationQuery,
  query => parseFloat(get(query, 'page', 1)),
);
export const getSearchSegment = createSelector(
  getSearchLocationQuery,
  query => get(query, SEARCH_FACETS.GPC_SEGMENT),
);
export const getSearchSelectedFacetIds = createSelector(
  getSearchLocationQuery,
  query => extractFacetIdsFromLocationQuery(query),
);
export const getSearchDatesRange = createSelector(
  getSearchLocationQuery,
  query => {
    let dates = [];
    const startDate = parseDate(get(query, 'startDate', null));
    const endDate = parseDate(get(query, 'endDate', null));
    if (!isEmpty(startDate) && !isEmpty(endDate)) {
      dates = [startDate, endDate];
    }
    return dates;
  },
);



// WEBPACK FOOTER //
// ./src/selectors/index.js